import { render, staticRenderFns } from "./ClientAddressChangeCard.vue?vue&type=template&id=0f92d5c6&"
import script from "./ClientAddressChangeCard.vue?vue&type=script&lang=js&"
export * from "./ClientAddressChangeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports